'use strict';

const SiteValues = {
  ww: () => { return window.innerWidth ? window.innerWidth : window.outerWidth; },
  wh: () => { return window.innerHeight ? window.innerHeight : window.outerHeight; },
  dh: () => {
    let v=Math.max.apply(null,[document.body.clientHeight,document.body.scrollHeight,document.documentElement.scrollHeight,document.documentElement.clientHeight]);
    return v;
  },
  st: () => { return window.scrollY; },
  hh: () => { return document.querySelector('.header').offsetHeight; },
  ua:navigator.userAgent
};

const isMobile = () => { return SiteValues.ww() <= 768 ? true : false; };
const isDesktop = () => { return SiteValues.ww() >= 769 ? true : false; };
const isTouch = () => { return (SiteValues.ua.indexOf('iPhone') >1 || SiteValues.ua.indexOf('iPad') >1 || SiteValues.ua.indexOf('Android') > 1) ? true : false; };

if (isTouch()) {
  document.body.classList.add('u-device-touch');
} else {
  document.body.classList.add('u-device-click');
}

const getQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  const data = {};
  for (const key of params.keys()) {
    if (key.endsWith('[]')) {
      const cleanKey = key.replace('[]', '');
      data[cleanKey] = params.getAll(key);
    } else if (!data[key]) {
      data[key] = params.get(key);
    }
  };
  return data;
};

class fadeToggle {
  constructor($target, duration = 400, delay = 40) {
    if (window.getComputedStyle($target).display === 'none') {
      this._fadeIn($target,duration,delay);
    } else {
      this._fadeOut($target,duration,delay);
    }
  }
  _fadeOut = (el, duration, delay) => {
    const coef = 1 / (duration / delay);
    el.style.opacity = 1.0;
    let opacity = Number(el.style.opacity);
    const animation = setInterval(() => {
      opacity -= coef;
      el.style.opacity = opacity;
      if (opacity <= 0) {
        el.style.display = 'none';
        clearInterval(animation);
      }
    }, delay);
  };
  _fadeIn = (el, duration, delay) => {
    const coef = 1 / (duration / delay);
    el.style.display = 'block';
    el.style.opacity = 0;
    let opacity = Number(el.style.opacity);
    const animation = setInterval(() => {
      opacity += coef;
      el.style.opacity = opacity;
      if (opacity >= 1) {
        clearInterval(animation);
      }
    }, delay);
  };
};

class slideToggle {
  constructor($target, duration = 400) {
    if (window.getComputedStyle($target).display === 'none') {
      this._slideDown($target, duration);
    } else {
      this._slideUp($target, duration);
    }
  }
  _slideUp = (el, duration) => {
    el.style.height = el.offsetHeight+'px';
    el.offsetHeight;
    el.style.transitionProperty = 'height,margin,padding';
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.style.transitionDuration = `${duration}ms`;
    el.style.transitionTimingFunction = 'ease';
    setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    }, duration);
  };
  _slideDown = (el, duration) => {
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty='height,margin,padding';
    el.style.height = `${height}px`;
    el.style.transitionDuration = `${duration}ms`;
    el.style.transitionTimingFunction = 'ease';
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    }, duration);
  };
};

class pageScroll {
  constructor($trigger, behavior) {
    let $tiggers = document.querySelectorAll($trigger);
    if ($tiggers.length) {
      $tiggers.forEach($this => {
        $this.addEventListener('click', event => {
          event.preventDefault();
          let hash = $this.getAttribute('href');
          hash = hash.replace(/^#([\d\D]+)/, '$1');
          let $hash = document.getElementById(hash);
          if ($hash) $hash.scrollIntoView({ behavior:behavior });
        });
      });
    }
  }
};

new pageScroll('a[href^="#"]','smooth');

class lazyContent {
  constructor ($lazy){
    this.$lazy = $lazy;
    this.bool = true;
    this.$triggers = document.querySelectorAll('.is-lazy-trigger');

    this._scroll();
    window.addEventListener('load', this._scroll);
    window.addEventListener('scroll', this._scroll);

    if (this.$triggers.length) {
      this.$triggers.forEach($trigger => {
        $trigger.addEventListener('click', () => {
          setTimeout(() => {
            this._scroll();
          }, 200);
        });
      });
    }
  }
  _scroll = () => {
    let wh = SiteValues.wh();
    let top = this.$lazy.getBoundingClientRect().top;
    let isHidden = this.$lazy.offsetParent === null ? true : false;
    if ((top - (wh / 1.6)) < -1 && this.bool && !isHidden) {
      this.bool = false;
      this.$lazy.classList.add('is-lazy-done');
    }
  };
};

const $lazys = document.querySelectorAll('.u-lazy');
if($lazys.length){
  $lazys.forEach($lazy => {
    new lazyContent($lazy);
  });
}

class toggleEvent {
  constructor ($trigger){
    this.$trigger = $trigger;
    this.bool = true;

    this.$trigger.addEventListener('click', () => {
      this._toggle();
    });
  }
  _toggleOpen = () => {
    const controls = this.$trigger.getAttribute('aria-controls');
    const $target = document.querySelector(`#${controls}`);
    if (!$target) return;
    this.$trigger.setAttribute('aria-expanded', 'true');
    $target.setAttribute('aria-hidden', 'false');
    new slideToggle($target);
  };
  _toggleClose = () => {
    const controls = this.$trigger.getAttribute('aria-controls');
    const $target = document.querySelector(`#${controls}`);
    if (!$target) return;
    this.$trigger.setAttribute('aria-expanded', 'false');
    $target.setAttribute('aria-hidden', 'true');
    new slideToggle($target);
  };
  _toggle = () => {
    const isExpanded = this.$trigger.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      this._toggleClose();
    } else {
      this._toggleOpen();
    };
  };
};

const $faqBoxLines = document.querySelectorAll('.section-faq-box__line');
if ($faqBoxLines.length) {
  $faqBoxLines.forEach($line => {
    let $trigger = $line.querySelector('.section-faq-box__q > button');
    let $targer = $line.querySelector('.section-faq-box__a');
    if ($trigger && $targer) new toggleEvent($trigger);
  });
}

class layoutHeader {
  constructor () {
    this.$t = document.querySelector('.l-hd');
    this.$linksItems = document.querySelectorAll('.l-hd-links__item');
    this.$gnavs = document.querySelectorAll('.l-gnav');

    this.$linksItems.forEach($item => {
      const $button = $item.querySelector(':scope > button');
      if (!$button) return;

      const $subLinks = $item.querySelector('.l-hd-sublinks');
      if (!$subLinks) return;

      let openTimer;
      let closeTimer;

      const openSubLinks = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => {
          this._subLinksOpen($button);
        }, 80);
      };

      const closeSubLinks = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          this._subLinksClose($button);
        }, 250);
      };

      $item.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        openSubLinks();
      });

      $item.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch') return;
        closeSubLinks();
      });

      $button.addEventListener('click', event => {
        event.preventDefault();
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        this._subLinksToggle($button);
      });
    });

    if (this.$gnavs.length) {
      this.$gnavs.forEach($gnav => {
        let id = $gnav.getAttribute('id');
        let $triggers = document.querySelectorAll(`[aria-controls="${id}"]`);
        let $linksItems = $gnav.querySelectorAll('.l-gnav-links__item');
    
        $triggers.forEach($trigger => {
          $trigger.addEventListener('click', event => {
            event.preventDefault();
            this.$gnavs.forEach($otherGnav => {
              let otherId = $otherGnav.getAttribute('id');
              let otherIsHidden = $otherGnav.getAttribute('aria-hidden');
              let $otherTriggers = document.querySelectorAll(`[aria-controls="${otherId}"]`);
              if (otherId != id && otherIsHidden === 'false') {
                this._gnavToggle($otherGnav, $otherTriggers);
              }
            });
            this._gnavToggle($gnav, $triggers);
          });
        });
    
        if ($linksItems.length) {
          $linksItems.forEach($item => {
            let $button = $item.querySelector(':scope > button');
            if ($button) {
              $button.addEventListener('click', event => {
                event.preventDefault();
                this._gnavSubLinksToggle($button);
              });
            }
          });
        }
      });
    }
  }
  _subLinksOpen = $button => {
    const controls = $button.getAttribute('aria-controls');
    const $target = document.querySelector(`#${controls}`);
    if (!$target) return;
    $button.setAttribute('aria-expanded', 'true');
    $target.setAttribute('aria-hidden', 'false');
  };
  _subLinksClose = $button => {
    const controls = $button.getAttribute('aria-controls');
    const $target = document.querySelector(`#${controls}`);
    if (!$target) return;
    $button.setAttribute('aria-expanded', 'false');
    $target.setAttribute('aria-hidden', 'true');
  };
  _subLinksToggle = $button => {
    const isExpanded = $button.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      this._subLinksClose($button);
    } else {
      this._subLinksOpen($button);
    };
  };
  _gnavToggle = ($gnav, $triggers) => {
    let isHidden = $gnav.getAttribute('aria-hidden');
    let isExpanded;
    if (isHidden === 'true') {
      isHidden = false;
      isExpanded = true;
    } else {
      isHidden = true;
      isExpanded = false;
    }
    $triggers.forEach($trigger => {
      $trigger.setAttribute('aria-expanded', isExpanded);
    });
    $gnav.setAttribute('aria-hidden', isHidden);
  };
  _gnavSubLinksToggle = $button => {
    let controls = $button.getAttribute('aria-controls');
    let $target = document.querySelector(`#${controls}`);
    let isExpanded = $button.getAttribute('aria-expanded');
    let isHidden = $target.getAttribute('aria-hidden');
    if (isExpanded === 'false') {
      isExpanded = true;
      isHidden = false;
    } else {
      isExpanded = false;
      isHidden = true;
    }
    $button.setAttribute('aria-expanded', isExpanded);
    $target.setAttribute('aria-hidden', isHidden);
    new slideToggle($target);
  };
};

const $layoutHeader = document.querySelectorAll('.l-hd');
if ($layoutHeader) new layoutHeader();

class layoutFooter {
  constructor () {
    this.$t = document.querySelector('.l-ft');
    this.$linksItems = document.querySelectorAll('.l-ft-links__item');

    this.$linksItems.forEach($item => {
      let $button = $item.querySelector(':scope > button');
      if ($button) {
        $button.addEventListener('click', event => {
          event.preventDefault();
          this._subLinksToggle($button);
        });
      };
    });
  }
  _subLinksToggle = $button => {
    let controls = $button.getAttribute('aria-controls');
    let $target = document.querySelector(`#${controls}`);
    let isExpanded = $button.getAttribute('aria-expanded');
    let isHidden = $target.getAttribute('aria-hidden');
    if (isExpanded === 'false') {
      isExpanded = true;
      isHidden = false;
    } else {
      isExpanded = false;
      isHidden = true;
    }
    $button.setAttribute('aria-expanded', isExpanded);
    $target.setAttribute('aria-hidden', isHidden);
    new slideToggle($target);
  };
};

const $layoutFooter = document.querySelectorAll('.l-ft');
if ($layoutFooter) new layoutFooter();
